import React from 'react';
import styled from 'styled-components';
import { useCart } from '../context/CartContext';
import { useLocalized } from '../hooks/useLocalized';

const NotificationOverlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #280212;
  color: white;
  z-index: 10001;
  transform: translateY(${props => props.isVisible ? '0' : '-100%'});
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 400;
  min-height: 60px;
`;

const NotificationText = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 12px;
  font-family: 'Cormorant Garamond', serif;
`;

const ViewButton = styled.button`
  background: white;
  color: #280212;
  border: none;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 16px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'Cormorant Garamond', serif;
`;

interface MobileCartNotificationProps {
  isVisible: boolean;
  onClose: () => void;
}

const MobileCartNotification: React.FC<MobileCartNotificationProps> = ({ isVisible, onClose }) => {
  const { state: cartState, showMobileCartDrawer } = useCart();
  const { getLocalized } = useLocalized();

  const handleViewCart = () => {
    showMobileCartDrawer();
    onClose();
  };

  if (!isVisible) return null;

  return (
    <NotificationOverlay isVisible={isVisible}>
      <NotificationText>
        {getLocalized('Ürün alışveriş sepetine eklendi', 'Product added to cart')} ({cartState.itemCount})
      </NotificationText>
      <ViewButton onClick={handleViewCart}>
        {getLocalized('Görüntüle', 'View')}
      </ViewButton>
    </NotificationOverlay>
  );
};

export default MobileCartNotification;
